const responses = [
    {id: 3, title: 'Vault ResAdd Response'},
    {id: 5, title: 'Vault ResTempAdd Response'},
    {id: 6, title: 'Vault Update Response'},
    {id: 8, title: 'Vault ResDelete Response'},
    {id: 9, title: 'Vault ResLookupFull Response'},
    {id: 10, title: 'Vault ResLookupMasked Response'},
    {id: 11, title: 'Vault ResGetExpiring Response'},
    {id: 12, title: 'Vault ResIscorporateCard Response'},
    {id: 13, title: 'Vault ResAddToken Response'},
    {id: 14, title: 'Vault ResTokenizeCC Response'},
    // {id: 16, title: 'Vault ResPurchaseCC Response'},
    // {id: 17, title: 'Vault ResPreauthCC Response'},
    // {id: 18, title: 'Vault ResIndRefundCC Response'},
    // {id: 19, title: 'Vault ResForcePostCC Full'},
    // {id: 20, title: 'Vault ResCardVerificationCC'},
]

export default responses